<div class="table-wrapper">
  <table
    mat-table
    [dataSource]="activityListDataSource"
    fixedLayout="true"
    class="main-table"
    #tableContainer
    >
    <!-- Attention Needed Column -->
    <ng-container matColumnDef="attention_needed">
      <th mat-header-cell *matHeaderCellDef>
        <span class="accessibility-text" translate="common_unviewed-submissions"></span>
      </th>
      <td mat-cell *matCellDef="let activity">
        <dot-indicator [activity]="activity"></dot-indicator>
      </td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>
        <span translate="common_name"></span>
      </th>
      <td mat-cell *matCellDef="let activity" [matTooltip]="activity.name">
        <span class="flex">
          <span class="activity-icon {{FirstCommentTourClasses.activityTablePulse}}">
            <i class="{{ isParentChildSyncEnabled(activity) ? 'ficon-activity-locked' : 'ficon-assignment' }}"></i>
          </span>
          <span class="activity-name">
            {{ activity.name }}
          </span>
        </span>
      </td>
    </ng-container>

    <!-- Due Date Column -->
    <ng-container matColumnDef="due_date">
      <th mat-header-cell *matHeaderCellDef>
        <span translate="activity-list_due-date"></span>
      </th>
      <td mat-cell *matCellDef="let activity">
        <ngx-activity-due-date [activity]="activity" [withDateLabel]="false"></ngx-activity-due-date>
      </td>
    </ng-container>

    <!-- Status Column -->
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>
        <span translate="modal-user-activity-history_status"></span>
      </th>
      <td mat-cell *matCellDef="let activity">
        <ngx-activity-list-status [activity]="activity"></ngx-activity-list-status>
      </td>
    </ng-container>

    <!-- Actions Column -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>
        <span class="accessibility-text" translate="common_actions"></span>
      </th>
      <td mat-cell *matCellDef="let activity" (click)="$event.stopPropagation();" (keyup.enter)="$event.stopPropagation()">
        <span class="flex">
          @if (activity.unviewed_comments) {
            <comment-indicator
              [unviewedComments]="activity.unviewed_comments">
            </comment-indicator>
          }
          @if (canOpenMenu()) {
            <button
              type="button"
              class="action-menu-btn icon-btn ficon-app-dots-vertical"
              data-cy="activity-options-dropdown-menu"
              [attr.aria-label]="'session-list-item_view-options' | translate"
              (click)="openMenu($event, activity)">
            </button>
          }
        </span>
      </td>
    </ng-container>

    <tr
      mat-header-row
      *matHeaderRowDef="displayColumns"
    ></tr>
    <tr
      mat-row
      tabindex="0"
      class="table-row {{FirstCommentTourClasses.activityTableComplete}}"
      [ngClass]="{ 'viewed': !unviewedState(activity) }"
      [attr.row-id]="activity.activity_id"
      [attr.aria-label]="activity.name"
      (contextmenu)="openMenu($event, activity)"
      (keyup.enter)="goToActivity.emit(activity)"
      (click)="goToActivity.emit(activity)"
      data-cy="activity-row-or-card"
      *matRowDef="let row; columns: displayColumns; let activity"
    ></tr>
  </table>

  <menu>
    <activity-menu [activity]="selectedActivity"></activity-menu>
  </menu>
</div>
